module.exports = __webpack_public_path__ + "assets/img/btn-officialSite-hover-bg-b88c2bbd.png";